// Badge / chip colorato
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
  {
    variants: {
      variant: {
        default: 'bg-[var(--fc-gray-100)] text-[var(--fc-foreground-muted)]',
        primary: 'bg-[color-mix(in_srgb,var(--fc-primary)_15%,transparent)] text-[var(--fc-primary)]',
        success: 'bg-[color-mix(in_srgb,var(--fc-success)_15%,transparent)] text-[var(--fc-success)]',
        warning: 'bg-[color-mix(in_srgb,var(--fc-warning)_15%,transparent)] text-[var(--fc-warning)]',
        danger: 'bg-[color-mix(in_srgb,var(--fc-danger)_15%,transparent)] text-[var(--fc-danger)]',
        info: 'bg-[color-mix(in_srgb,var(--fc-info)_15%,transparent)] text-[var(--fc-info)]',
        accent: 'bg-[color-mix(in_srgb,var(--fc-accent)_15%,transparent)] text-[var(--fc-accent)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {
  dot?: boolean
}

export function Badge({ className, variant, dot, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props}>
      {dot && (
        <span
          className="mr-1.5 h-1.5 w-1.5 rounded-full bg-current"
          aria-hidden="true"
        />
      )}
      {children}
    </span>
  )
}
